export const dynamicSequence = (sections_info, isFromEdit) => {
  let orIndex = 0;
  let question_id_sequence = 0;

  // Track the last non-OR paragraph's question numbers for matching
  let lastNonOrParagraphStart = 0;
  let lastNonOrParagraphSubID = null;
  let orParagraphPositionInGroup = 0; // Position within current OR paragraph

  let data = sections_info?.map((section, i) => {
    return {
      ...section,
      divisions: section?.divisions?.map((div, j) => {
        return {
          ...div,
          question_data: div.question_data?.map((question, k) => {
            question_id_sequence++;

            // Handle paragraph questions with OR
            if (question.isOr && question.subID) {
              // Check if this is the first question of an OR paragraph
              if (question.paragraph) {
                // Start of a new OR paragraph - reset position counter
                orParagraphPositionInGroup = 0;
              }

              orParagraphPositionInGroup++;
              orIndex++; // Increment to offset from global sequence

              // The question_id should match the position as if it were in the first paragraph
              // Use the last non-OR paragraph's starting number + position in paragraph
              const question_id = isFromEdit
                ? question?.question_id
                : (lastNonOrParagraphStart + orParagraphPositionInGroup - 1).toString();

              return {
                ...question,
                question_id: question_id,
              };
            }

            // Track non-OR paragraph starting numbers
            if (!question.isOr && question.subID && question.paragraph) {
              // This is the first question of a non-OR paragraph
              lastNonOrParagraphStart = question_id_sequence - orIndex;
              lastNonOrParagraphSubID = question.subID;
            }

            // Standard OR/AND handling (non-paragraph)
            if (
              question.isOr ||
              (question.questionRight && !question.questionLeft) ||
              question.andId > 1
            ) {
              orIndex += 1;
            }

            const question_id = isFromEdit
              ? question?.question_id
              : (Number(question_id_sequence) - orIndex).toString();

            return {
              ...question,
              question_id:
                question.questionRight && !question.questionLeft
                  ? ''
                  : question_id,
            };
          }),
        };
      }),
    };
  });

  return data;
};